import mcSettings from './message-constants';

const responseLinkSettings = {
    responseLinks: {
        skipConditionLists: [],
        validMessageTypes: [
            mcSettings.messageConstants.converseRequest,
            mcSettings.messageConstants.requestUnitRequest,
            mcSettings.messageConstants.appeventRequest,
            mcSettings.messageConstants.getHistoryRequest,
        ],
    },
};

export default responseLinkSettings;


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/response-links.ts